export default __webpack_public_path__ + "static/media/354.f140660a.jpg";